var locales = {
  en: {
    ADD_ITEM: 'Add item',
    DELETE_ALL: 'Delete all'
  },
  es: {
    ADD_ITEM: 'Agregar elemento',
    DELETE_ALL: 'Eliminar todo'
  },
  pt: {
    ADD_ITEM: 'Adicionar item',
    DELETE_ALL: 'Excluir tudo'
  }
};
export default locales;